'use strict';

var _ = require('lodash');
var RomSummaryThematicChartsDataPreparationService = function RomSummaryThematicChartsDataPreparationService(configurationService, $filter, optWeekService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var labels = {
    dow: {},
    cabin: {},
    d2dBucket: {}
  };
  function getBuckets() {
    var RTPS = configurationService.getRTPS().split(',').map(Number);
    var buckets = [];
    var end;
    for (var i = 0, RTPSLength = RTPS.length; i < RTPSLength; i++) {
      var beginning = RTPS[i];
      if (i === RTPSLength - 1) {
        end = 330;
      } else {
        end = RTPS[i + 1] - 1;
      }
      buckets.push(beginning + '-' + end);
    }
    return buckets;
  }
  function prepareForTrendOpportunity(data) {
    var result = [];
    for (var i = 0; i < data.length; i++) {
      var r = data[i];
      var spill = r.actSpill - r.maxSpill;
      if (isNaN(spill)) {
        spill = undefined;
      }
      var recapture = r.maxRecapture - r.actRecapture;
      if (isNaN(recapture)) {
        recapture = undefined;
      }
      var revOptPercent = Math.min((r.actRevenue - _.min([r.actRevenue, r.maxRevenue, r.minRevenue])) / Math.abs(r.maxRevenue - r.minRevenue) * 100, 200);
      if (isNaN(revOptPercent)) {
        revOptPercent = undefined;
      }
      var circlesData = _.isNumber(revOptPercent) ? [{
        css: 'circle-rev-opt',
        value: revOptPercent
      }] : [];
      var tiles = spill / recapture > 1 ? [{
        value: recapture,
        className: 'recapture-bar'
      }] : [];
      var element = {
        date: r.date,
        dimension: r.dimension,
        recapture: recapture,
        spill: spill,
        tiles: tiles,
        circles: circlesData,
        revOpp: revOptPercent,
        stackLabel: formatStackLabel(r.dimension),
        isHidden: r.isHidden
      };
      result.push(element);
    }
    return result;
  }
  function prepareForMinActMaxRevenue(data) {
    var result = [{
      curveData: [],
      className: 'curve-act-revenue'
    }, {
      curveData: [],
      className: 'curve-max-revenue'
    }, {
      curveData: [],
      className: 'curve-min-revenue'
    }];
    for (var i = 0; i < data.length; i++) {
      var r = data[i];
      result[0].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.actRevenue) ? undefined : r.actRevenue,
        stackLabel: formatStackLabel(r.dimension)
      });
      result[1].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.maxRevenue) ? undefined : r.maxRevenue,
        stackLabel: formatStackLabel(r.dimension)
      });
      result[2].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.minRevenue) ? undefined : r.minRevenue,
        stackLabel: formatStackLabel(r.dimension)
      });
    }
    return result;
  }
  function prepareForDemandAndPaxVsOptimal(data) {
    var result = [{
      curveData: [],
      className: 'curve-act-pax'
    }, {
      curveData: [],
      className: 'curve-opt-pax'
    }, {
      curveData: [],
      className: 'curve-demand'
    }];
    for (var i = 0; i < data.length; i++) {
      var r = data[i];
      result[0].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.actSale) ? undefined : r.actSale,
        stackLabel: formatStackLabel(r.dimension)
      });
      result[1].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.maxSale) ? undefined : r.maxSale,
        stackLabel: formatStackLabel(r.dimension)
      });
      result[2].curveData.push({
        dimension: r.dimension,
        value: isNaN(r.fcDemand) ? undefined : r.fcDemand,
        stackLabel: formatStackLabel(r.dimension)
      });
    }
    return result;
  }
  function prepareForAvgFareVsOptimal(data) {
    var result = [{
      curveData: [],
      className: 'curve-fare-act'
    }, {
      curveData: [],
      className: 'curve-fare-opt'
    }];
    for (var i = 0; i < data.length; i++) {
      var r = data[i];
      var value = [r.actRevenue / r.actSale, r.maxRevenue / r.maxSale];
      result[0].curveData.push({
        dimension: r.dimension,
        value: isNaN(value[0]) ? undefined : value[0],
        stackLabel: formatStackLabel(r.dimension)
      });
      result[1].curveData.push({
        dimension: r.dimension,
        value: isNaN(value[1]) ? undefined : value[1],
        stackLabel: formatStackLabel(r.dimension)
      });
    }
    return result;
  }
  function prepareForDemandWeightedOpenPercentVsOptimal(data) {
    var result = [{
      curveData: [],
      className: 'curve-act-open'
    }, {
      curveData: [],
      className: 'curve-opt-open'
    }];
    for (var i = 0; i < data.length; i++) {
      var r = data[i];
      var value = [r.actOpenFcDemand / r.fcDemand * 100, r.maxOpenFcDemand / r.fcDemand * 100];
      result[0].curveData.push({
        dimension: r.dimension,
        value: isNaN(value[0]) ? undefined : value[0],
        stackLabel: formatStackLabel(r.dimension)
      });
      result[1].curveData.push({
        dimension: r.dimension,
        value: isNaN(value[1]) ? undefined : value[1],
        stackLabel: formatStackLabel(r.dimension)
      });
    }
    return result;
  }
  function formatStackLabel(value) {
    return value && value.toISOString ? rmMomentFormat(value, 'DATE_USER_SETTINGS') : value;
  }
  function groupData(attr) {
    return function (data) {
      var grouped = {};
      var groupedArray = [];
      var index, dataLength, groupedLength, labelsLength;
      var buckets = getBuckets();
      if (attr !== 'week') {
        for (index = 0, dataLength = labels[attr].length; index < dataLength; index++) {
          grouped[labels[attr][index]] = {
            dimension: labels[attr][index]
          };
        }
      }
      for (index = 0, labelsLength = data.length; index < labelsLength; index++) {
        var source = data[index];
        var targetIndex = source[attr];
        if (attr === 'd2dBucket') {
          targetIndex = buckets[targetIndex];
        }
        var target = grouped[targetIndex];
        if (target === undefined) {
          target = {};
        }
        target.actRecapture = (target.actRecapture || 0) + source.actRecapture;
        target.actRevenue = (target.actRevenue || 0) + source.actRevenue;
        target.actSpill = (target.actSpill || 0) + source.actSpill;
        target.maxRecapture = (target.maxRecapture || 0) + source.maxRecapture;
        target.maxRevenue = (target.maxRevenue || 0) + source.maxRevenue;
        target.maxSpill = (target.maxSpill || 0) + source.maxSpill;
        target.minRevenue = (target.minRevenue || 0) + source.minRevenue;
        target.fcDemand = (target.fcDemand || 0) + source.fcDemand;
        target.actSale = (target.actSale || 0) + source.actSale;
        target.maxSale = (target.maxSale || 0) + source.maxSale;
        target.actOpenFcDemand = (target.actOpenFcDemand || 0) + source.actOpenFcDemand;
        target.maxOpenFcDemand = (target.maxOpenFcDemand || 0) + source.maxOpenFcDemand;
        target.cabin = source.cabin;
        target.romTimeBucket = source.d2dBucket;
        target.d2dBucket = buckets[source.d2dBucket];
        target.dow = source.dow;
        target.fullDow = source.fullDow;
        target.week = source.week;
        target.resType = source.resType;
        target.pos = source.pos;
        target.optGroupWeek = source.optGroupWeek;
        target.date = target.date || source.date.setDay(configurationService.getROMWeekEndDOW());
        if (attr === 'week') {
          target.dimension = target.date;
        } else {
          target.dimension = target[attr];
        }
        grouped[target[attr]] = target;
      }
      var groupedKeys = Object.keys(grouped);
      for (index = 0, groupedLength = groupedKeys.length; index < groupedLength; index++) {
        var sourceAttr = groupedKeys[index];
        groupedArray.push(grouped[sourceAttr]);
      }
      return groupedArray;
    };
  }
  function setLabels(data) {
    labels = {
      fullDow: {},
      cabin: {},
      d2dBucket: {},
      resType: {},
      pos: {}
    };
    var daysOfWeek = optWeekService.getDaysOfWeek(false, true);
    var buckets = getBuckets();
    var dataLength = data.length;
    for (var i = 0; i < dataLength; i++) {
      labels.fullDow[data[i].fullDow] = true;
      labels.d2dBucket[buckets[data[i].d2dBucket]] = true;
      labels.cabin[data[i].cabin] = true;
      labels.resType[data[i].resType] = true;
      labels.pos[data[i].pos] = true;
    }
    labels.fullDow = daysOfWeek.filter(function (day) {
      return labels.fullDow[day];
    });
    labels.d2dBucket = Object.keys(labels.d2dBucket).sort(function (a, b) {
      return parseInt(a) - parseInt(b);
    });
    labels.cabin = Object.keys(labels.cabin).sort();
    labels.resType = Object.keys(labels.resType);
    labels.pos = Object.keys(labels.pos).sort();
    return data;
  }
  function createEmptyItem(initElem, filterType) {
    var result = {
      date: initElem.date,
      dimension: initElem.dimension,
      isHidden: true,
      optGroupWeek: initElem.optGroupWeek,
      cabin: initElem.cabin,
      dow: initElem.dow,
      romTimeBucket: initElem.romTimeBucket,
      resType: initElem.resType,
      pos: initElem.pos
    };
    result[filterType] = initElem[filterType];
    return result;
  }
  function mergeData(initData, data, filterType) {
    var result = [];
    for (var i = 0; i < initData.length; i++) {
      var idx = _.findIndex(data, {
        dimension: initData[i].dimension
      });
      if (idx === -1) {
        result.push(createEmptyItem(initData[i], filterType));
      } else {
        result.push(data[idx]);
      }
    }
    return result;
  }
  return {
    prepareForTrendOpportunity: prepareForTrendOpportunity,
    prepareForMinActMaxRevenue: prepareForMinActMaxRevenue,
    prepareForDemandAndPaxVsOptimal: prepareForDemandAndPaxVsOptimal,
    prepareForAvgFareVsOptimal: prepareForAvgFareVsOptimal,
    prepareForDemandWeightedOpenPercentVsOptimal: prepareForDemandWeightedOpenPercentVsOptimal,
    groupData: groupData,
    setLabels: setLabels,
    mergeData: mergeData
  };
};
RomSummaryThematicChartsDataPreparationService.$inject = ['ConfigurationService', '$filter', 'OptWeekService'];
module.exports = RomSummaryThematicChartsDataPreparationService;